<template>
  <div class="login-page">
    <router-link class="login-brand" to="/" aria-label="返回纳微创新首页">
      <img class="brand-logo" src="@/assets/img/logo.png" alt="纳微创新" />
      <img class="brand-certification" src="@/assets/img/logo2.png" alt="MA与CNAS认证" />
    </router-link>

    <section
      class="login-panel"
      :class="{
        'qr-panel': activeIndex === 1,
        'wx-auth-panel': activeIndex === 4,
      }"
    >
      <button
        class="mode-corner"
        type="button"
        :title="activeIndex === 1 || activeIndex === 4 ? '返回账号登录' : '微信扫码登录'"
        @click="toggleQrLogin"
      >
        <i :class="activeIndex === 1 || activeIndex === 4 ? 'el-icon-user' : 'el-icon-full-screen'"></i>
      </button>

      <template v-if="activeIndex === 1">
        <h1 class="qr-title">微信登录</h1>
        <div class="qr-code-frame">
          <span class="corner top-left"></span>
          <span class="corner top-right"></span>
          <span class="corner bottom-left"></span>
          <span class="corner bottom-right"></span>
          <div v-if="!qrCodeData.imageLoaded" class="qr-loading" aria-live="polite">
            <i class="el-icon-loading"></i>
            <span>二维码加载中</span>
          </div>
          <img
            v-show="qrCodeData.imageLoaded"
            class="login-qr-code"
            :src="qrCodeData.loginQrCode"
            alt="微信登录二维码"
            @load="handleQrImageLoad"
          />
          <button
            v-if="qrCodeData.loginQRCodeStatus === 'timeout'"
            type="button"
            class="qr-cover"
            @click="refreshLoginQrCode"
          >
            二维码已失效<br />点击刷新
          </button>
        </div>
        <div class="qr-subtitle">微信扫码 1 秒登录</div>
        <div class="qr-agreement">
          扫码代表您同意
          <a href="/registrationAgreement" target="_blank">《纳微创新用户注册协议》</a>
          与
          <a href="/privacyAgreement" target="_blank">《纳微创新用户隐私协议》</a>
        </div>
      </template>

      <template v-else-if="activeIndex === 4">
        <h1 class="wx-auth-title">微信授权登录</h1>
        <div class="wx-auth-frame-wrap">
          <div v-if="!wxLoginLoaded" class="wx-auth-loading" aria-live="polite">
            <i class="el-icon-loading"></i>
            <span>微信授权页面加载中</span>
          </div>
          <div id="wx-login-container" class="wx-auth-container"></div>
        </div>
      </template>

      <template v-else>
        <div class="login-tabs">
          <button
            v-for="item in loginTabs"
            :key="item.index"
            type="button"
            :class="{ active: activeIndex === item.index }"
            @click="switchLoginMode(item.index)"
          >
            {{ item.name }}
          </button>
        </div>

        <el-form
          v-show="activeIndex === 2"
          ref="smsForm"
          :model="loginForm"
          :rules="smsRules"
          class="login-form"
          @keyup.enter.native="submitLogin"
        >
          <el-form-item prop="phoneNumber">
            <el-input v-model="loginForm.phoneNumber" placeholder="手机号">
              <i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="smsCode" class="verification-item">
            <el-input v-model="loginForm.smsCode" placeholder="验证码">
              <i slot="prefix" class="el-input__icon el-icon-lock"></i>
            </el-input>
            <el-button
              class="verification-button"
              :disabled="!showCodeButton"
              @click="sendSmsCode"
            >
              {{ showCodeButton ? '获取验证码' : count + 'S' }}
            </el-button>
          </el-form-item>
        </el-form>

        <el-form
          v-show="activeIndex === 3"
          ref="passwordForm"
          :model="loginForm"
          :rules="passwordRules"
          class="login-form"
          @keyup.enter.native="submitLogin"
        >
          <el-form-item prop="loginAccount">
            <el-input v-model="loginForm.loginAccount" placeholder="手机号/邮箱">
              <i slot="prefix" class="el-input__icon el-icon-user"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="loginForm.password" type="password" show-password placeholder="密码">
              <i slot="prefix" class="el-input__icon el-icon-lock"></i>
            </el-input>
          </el-form-item>
        </el-form>

        <div
          class="submit-button"
          :class="{ disabled: submitting }"
          :aria-disabled="submitting"
          @click="submitLogin"
        >
          {{ submitting ? "登录中..." : "登录/注册" }}
        </div>
        <button class="back-home-button" type="button" @click="returnHome">返回首页</button>

        <div v-if="activeIndex === 3" class="forgot-row">
          <el-button type="text" @click="showFindPassword">忘记密码？</el-button>
        </div>

        <div class="third-party-divider"><span>第三方账号登录</span></div>
        <button class="wechat-button" type="button" title="微信登录" @click="WXLogin()">
          <img src="@/assets/img/wx.png" alt="微信登录" />
        </button>

        <div class="agreement" :class="{ warning: showPrivacyWarning }">
          <el-checkbox v-model="privacyChecked"></el-checkbox>
          <span>
            登录或注册代表您同意
            <a href="/registrationAgreement" target="_blank">《纳微创新用户注册协议》</a>
            与
            <a href="/privacyAgreement" target="_blank">《纳微创新用户隐私协议》</a>
          </span>
        </div>
        <div v-if="showPrivacyWarning" class="agreement-error">请先阅读并同意用户协议与隐私协议</div>
      </template>
    </section>

    <footer class="login-footer">
      <div class="platform-name">纳微创新·一站式科研服务平台</div>
      <div class="copyright">
        Copyright © 湖南纳微新材料科技有限公司 All Rights Reserved 服务热线：400-168-0661
      </div>
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer">
        湘ICP备2021016992号-1
      </a>
    </footer>

    <find-password
      v-if="findPasswordVisible"
      ref="findPassword"
      @cancel="findPasswordVisible = false"
    ></find-password>
  </div>
</template>

<script>
import {
  createSceneLogin,
  getLoginStatus,
  getWebLoginInfo,
  login,
  sendCode,
} from "@/api/request";
import {
  setLoginCookie,
  setToken,
} from "@/plugins/auth";
import { isMobile } from "@/plugins/validate";
import findPassword from "./findPassword";


export default {
  name: "LoginPage",
  components: {
    findPassword,
  },
  data() {
    const validateMobile = (rule, value, callback) => {
      if(!isMobile(value)) return callback(new Error("请输入正确的手机号"));
      callback();
    };
    const validateLoginAccount = (rule, value, callback) => {
      const emailRule = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if(!isMobile(value) && !emailRule.test(value)) {
        return callback(new Error("请输入正确的手机号/邮箱"));
      }
      callback();
    };
    return {
      activeIndex: 2,
      privacyChecked: true,
      showPrivacyWarning: false,
      submitting: false,
      findPasswordVisible: false,
      wxLoginLoaded: false,
      wxLoginCleanup: null,
      showCodeButton: true,
      count: 0,
      codeTimer: null,
      loginTabs: [
        { name: "验证码登录", index: 2 },
        { name: "密码登录", index: 3 },
      ],
      loginForm: {
        phoneNumber: "",
        email: "",
        loginAccount: "",
        smsCode: "",
        password: "",
      },
      smsRules: {
        phoneNumber: [
          { required: true, trigger: "blur", message: "请输入手机号" },
          { validator: validateMobile, trigger: "blur" },
        ],
        smsCode: [
          { required: true, trigger: "blur", message: "请输入验证码" },
        ],
      },
      passwordRules: {
        loginAccount: [
          { required: true, trigger: "blur", message: "请输入手机号/邮箱" },
          { validator: validateLoginAccount, trigger: "blur" },
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入密码" },
        ],
      },
      qrCodeData: {
        loginQRCodeStatus: "noGet",
        scene: "",
        loginQrCode: "",
        imageLoaded: false,
        expiryTimer: null,
        checkLoginTimer: null,
      },
    };
  },
  created() {
    document.body.classList.add("login-route-page");
    const mode = this.$route.query.mode;
    this.activeIndex = mode === "wechat" ? 1 : mode === "password" ? 3 : 2;
  },
  mounted() {
    if(this.activeIndex === 1) {
      this.getLoginQrCode();
    }
  },
  beforeDestroy() {
    document.body.classList.remove("login-route-page");
    this.clearWXLogin();
    this.clearQrTimers();
    clearInterval(this.codeTimer);
  },
  methods: {
    async WXLogin() {
      // 微信授权回调进入站点首页，由首页处理 code 并完成快速登录。
      const redirectUri = "https://www.navi-sci.cn";
      const state = Math.random().toString(36).slice(2);

      // 将微信官方授权组件挂载到当前登录卡片。
      this.clearWXLogin();
      this.wxLoginLoaded = false;
      this.activeIndex = 4;
      await this.$nextTick();

      try {
        await this.loadWXLoginScript();
        if(this.activeIndex !== 4) return;
        const wxLoginOptions = {
          self_redirect: false,
          id: "wx-login-container",
          appid: "wxce353fe46ac0a2d6",
          scope: "snsapi_login",
          redirect_uri: encodeURIComponent(redirectUri),
          state,
          stylelite: 1,
          onQRcodeReady: () => {
            this.wxLoginLoaded = true;
          },
        };
        new window.WxLogin(wxLoginOptions);
        this.wxLoginCleanup = wxLoginOptions.onCleanup;
      } catch(error) {
        this.switchLoginMode(2);
        this.$message.error("微信授权页面加载失败，请稍后重试");
      }
    },
    loadWXLoginScript() {
      if(window.WxLogin) return Promise.resolve();

      return new Promise((resolve, reject) => {
        const existingScript = document.getElementById("wx-login-script");
        if(existingScript) {
          existingScript.addEventListener("load", resolve, { once: true });
          existingScript.addEventListener("error", reject, { once: true });
          return;
        }

        const script = document.createElement("script");
        script.id = "wx-login-script";
        script.src = "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js";
        script.onload = resolve;
        script.onerror = error => {
          script.remove();
          reject(error);
        };
        document.head.appendChild(script);
      });
    },
    clearWXLogin() {
      if(this.wxLoginCleanup) this.wxLoginCleanup();
      this.wxLoginCleanup = null;
      this.wxLoginLoaded = false;

      const container = document.getElementById("wx-login-container");
      if(container) container.innerHTML = "";
    },
    switchLoginMode(index) {
      if(this.activeIndex === index) return;
      if(this.activeIndex === 4) {
        this.clearWXLogin();
      }
      this.activeIndex = index;
      this.showPrivacyWarning = false;
      if(index === 1) {
        this.getLoginQrCode();
        return;
      }
      this.clearQrTimers();
      this.$nextTick(() => {
        const form = index === 2 ? this.$refs.smsForm : this.$refs.passwordForm;
        if(form) form.clearValidate();
      });
    },
    toggleQrLogin() {
      this.switchLoginMode(this.activeIndex === 1 || this.activeIndex === 4 ? 2 : 1);
    },
    async submitLogin() {
      // 登录提交期间锁定入口，避免点击与回车重复调用接口。
      if(this.submitting) return;
      if(!this.privacyChecked) {
        this.showPrivacyWarning = true;
        return;
      }
      this.showPrivacyWarning = false;
      this.submitting = true;
      try {
        const form = this.activeIndex === 2 ? this.$refs.smsForm : this.$refs.passwordForm;
        const valid = await new Promise(resolve => form.validate(resolve));
        if(!valid) return;

        const loginData = this.getLoginData();
        const res = await login(loginData);
        await this.completeLogin(res.data.access_token);
        await this.$router.replace(this.getRedirectPath());
      } catch(error) {
        this.$message.error(error.msg || error.message || error || "登录失败，请稍后重试");
      } finally {
        this.submitting = false;
      }
    },
    getLoginData() {
      const inviteInfo = {};
      if(this.$route.query.inviterPhoneNumber) {
        inviteInfo.inviterPhoneNumber = this.$route.query.inviterPhoneNumber;
        inviteInfo.inviterType = this.$route.query.inviterType;
      }
      if(this.activeIndex === 2) {
        return {
          phoneNumber: this.loginForm.phoneNumber,
          smsCode: this.loginForm.smsCode,
          ...inviteInfo,
        };
      }
      const emailRule = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return {
        loginAccount: this.loginForm.loginAccount,
        phoneNumber: isMobile(this.loginForm.loginAccount) ? this.loginForm.loginAccount : undefined,
        email: emailRule.test(this.loginForm.loginAccount) ? this.loginForm.loginAccount : undefined,
        password: this.loginForm.password,
        ...inviteInfo,
      };
    },
    async completeLogin(token) {
      setToken(token);
      setLoginCookie(token);
      this.$store.commit("SET_TOKEN", token);
      this.$store.commit("SET_LOGINFLAG", 1);
      await Promise.all([
        this.$store.dispatch("GetInfo"),
        this.$store.dispatch("setKefuQRCode"),
      ]);
      this.clearQrTimers();
      this.$message.success("登录成功");
    },
    getRedirectPath() {
      const redirect = this.$route.query.redirect;
      return typeof redirect === "string"
        && redirect.startsWith("/")
        && !redirect.startsWith("//")
        && !redirect.startsWith("/login")
        ? redirect
        : "/";
    },
    // 返回网站首页。
    returnHome() {
      this.$router.push("/");
    },
    showFindPassword() {
      this.findPasswordVisible = true;
      this.$nextTick(() => {
        this.$refs.findPassword.init();
        this.$refs.findPassword.clearFindForm();
      });
    },
    sendSmsCode() {
      if(!isMobile(this.loginForm.phoneNumber)) {
        this.$refs.smsForm.validateField("phoneNumber");
        return;
      }
      sendCode({ phoneNumber: this.loginForm.phoneNumber }).then(res => {
        if(res.code !== 200) return;
        this.count = 60;
        this.showCodeButton = false;
        this.codeTimer = setInterval(() => {
          this.count -= 1;
          if(this.count > 0) return;
          clearInterval(this.codeTimer);
          this.codeTimer = null;
          this.showCodeButton = true;
        }, 1000);
      });
    },
    getLoginQrCode() {
      this.clearQrTimers();
      this.qrCodeData.loginQRCodeStatus = "noGet";
      this.qrCodeData.loginQrCode = "";
      this.qrCodeData.imageLoaded = false;
      createSceneLogin({ width: 400 }).then(res => {
        this.qrCodeData.scene = res.data.scene;
        this.qrCodeData.loginQrCode =
          "https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=" + res.data.ticket;
        this.qrCodeData.loginQRCodeStatus = "wait";
        this.qrCodeData.expiryTimer = setTimeout(() => {
          this.qrCodeData.loginQRCodeStatus = "timeout";
          clearTimeout(this.qrCodeData.checkLoginTimer);
        }, 5 * 60 * 1000);
        this.checkAppLogin();
      });
    },
    handleQrImageLoad() {
      this.qrCodeData.imageLoaded = true;
    },
    checkAppLogin() {
      if(this.qrCodeData.loginQRCodeStatus !== "wait") return;
      this.qrCodeData.checkLoginTimer = setTimeout(() => {
        getLoginStatus({ scene: this.qrCodeData.scene }).then(res => {
          this.qrCodeData.loginQRCodeStatus = res.data.status;
          if(res.data.status === "wait") this.checkAppLogin();
          if(res.data.status === "success") this.afterWechatLogin();
        });
      }, 3000);
    },
    refreshLoginQrCode() {
      this.getLoginQrCode();
    },
    async afterWechatLogin() {
      try {
        const res = await getWebLoginInfo({ scene: this.qrCodeData.scene });
        if(res.code !== 200) {
          this.$message.error(res.msg);
          return;
        }
        await this.completeLogin(res.token);
        await this.$router.replace(this.getRedirectPath());
      } catch(error) {
        this.$message.error(error.msg || error.message || "微信登录失败，请稍后重试");
      }
    },
    clearQrTimers() {
      clearTimeout(this.qrCodeData.expiryTimer);
      clearTimeout(this.qrCodeData.checkLoginTimer);
      this.qrCodeData.expiryTimer = null;
      this.qrCodeData.checkLoginTimer = null;
    },
  },
};
</script>

<style lang="scss">
body.login-route-page {
  overflow: auto;
}
body.login-route-page #app {
  min-width: 0 !important;
}
</style>

<style lang="scss" scoped>
.login-page {
  position: relative;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: auto minmax(min-content, 1fr) auto;
  gap: 24px;
  min-height: 100vh;
  padding: 26px 48px 18px;
  color: #52647f;
  background: #f6f8fa;
}
.login-brand {
  display: flex;
  gap: 18px;
  align-items: center;
  width: max-content;
  text-decoration: none;
}
.brand-logo {
  display: block;
  width: 144px;
  height: auto;
}
.brand-certification {
  display: block;
  width: 92px;
  height: auto;
}
.login-panel {
  position: relative;
  place-self: center;
  box-sizing: border-box;
  width: 386px;
  min-height: 440px;
  padding: 34px 32px 28px;
  overflow: hidden;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 12px 28px rgba(44, 57, 75, 0.14);
}
.login-panel.qr-panel {
  min-height: 430px;
  padding-top: 32px;
}
.login-panel.wx-auth-panel {
  min-height: 480px;
  padding: 28px 24px 20px;
}
.mode-corner {
  position: absolute;
  top: 0;
  right: 0;
  width: 58px;
  height: 58px;
  padding: 0 5px 23px 27px;
  color: #fff;
  cursor: pointer;
  background: linear-gradient(225deg, #5CC300 0 50%, #eefbf9 51% 62%, transparent 63%);
  border: 0;
  font-size: 18px;
}
.login-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 26px;
}
.login-tabs button {
  height: 42px;
  color: #52647f;
  cursor: pointer;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  font-size: 15px;
}
.login-tabs button.active {
  color: #5CC300;
  border-bottom-color: #5CC300;
}
.login-form ::v-deep .el-form-item {
  margin-bottom: 16px;
}
.login-form ::v-deep .el-input__inner {
  height: 38px;
  border-color: #d8e0ea;
  border-radius: 6px;
  color: #52647f;
}
.verification-item ::v-deep .el-form-item__content {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 104px;
  gap: 10px;
}
.verification-item ::v-deep .el-form-item__content::before,
.verification-item ::v-deep .el-form-item__content::after {
  display: none;
}
.verification-item ::v-deep .el-input {
  grid-row: 1;
  grid-column: 1;
}
.verification-button {
  grid-row: 1;
  grid-column: 2;
  height: 38px;
  padding: 0 10px;
  color: #5CC300;
}
.submit-button {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 38px;
  margin-top: 1px;
  font-weight: 600;
  background: linear-gradient(to right, #9FFFD7, #BAFF75);
  border-radius: 6px;
}
.submit-button.disabled {
  cursor: not-allowed;
  opacity: 0.65;
}
.back-home-button {
  display: block;
  padding: 0;
  margin: 12px auto 0;
  color: #52647f;
  cursor: pointer;
  background: transparent;
  border: 0;
  font-size: 14px;
}
.back-home-button:hover,
.back-home-button:focus {
  color: #5CC300;
}
.forgot-row {
  height: 34px;
  text-align: right;
}
.forgot-row .el-button {
  padding: 9px 0 0;
  color: #5CC300;
}
.third-party-divider {
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 21px 0 14px;
  font-size: 13px;
  text-align: center;
}
.third-party-divider::before,
.third-party-divider::after {
  flex: 1;
  height: 1px;
  content: "";
  background: #dce3eb;
}
.wechat-button {
  display: block;
  width: 42px;
  height: 42px;
  padding: 0;
  margin: 0 auto 15px;
  cursor: pointer;
  background: transparent;
  border: 0;
  border-radius: 50%;
}
.wechat-button img {
  display: block;
  width: 42px;
  height: 42px;
}
.agreement {
  display: grid;
  grid-template-columns: 16px 1fr;
  gap: 8px;
  align-items: start;
  padding: 6px 0;
  font-size: 12px;
  line-height: 18px;
}
.agreement.warning {
  color: #f56c6c;
}
.agreement a,
.qr-agreement a {
  color: #5CC300;
  text-decoration: none;
}
.agreement-error {
  color: #f56c6c;
  font-size: 12px;
}
.qr-title,
.wx-auth-title {
  margin: 0 0 25px;
  color: #172033;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
}
.wx-auth-title {
  margin-bottom: 8px;
  text-align: center;
}
.wx-auth-frame-wrap {
  position: relative;
  height: 410px;
  overflow: hidden;
  background: #fff;
}
.wx-auth-container {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  padding-top: 25%;
}
.wx-auth-container ::v-deep iframe {
  display: block;
  max-width: 100%;
  border: 0;
}
.wx-auth-loading {
  position: absolute;
  z-index: 1;
  inset: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  justify-content: center;
  color: #5CC300;
  background: #fff;
  font-size: 13px;
}
.wx-auth-loading i {
  font-size: 28px;
}
.qr-code-frame {
  position: relative;
  width: 184px;
  height: 184px;
  margin: 0 auto 16px;
}
.login-qr-code {
  display: block;
  width: 150px;
  height: 150px;
  padding: 17px;
}
.qr-loading {
  position: absolute;
  inset: 17px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  justify-content: center;
  color: #5CC300;
  background: #f7fbfb;
  font-size: 13px;
}
.qr-loading i {
  font-size: 28px;
}
.corner {
  position: absolute;
  width: 22px;
  height: 22px;
  border-color: #5CC300;
  border-style: solid;
}
.top-left {
  top: 0;
  left: 0;
  border-width: 3px 0 0 3px;
}
.top-right {
  top: 0;
  right: 0;
  border-width: 3px 3px 0 0;
}
.bottom-left {
  bottom: 0;
  left: 0;
  border-width: 0 0 3px 3px;
}
.bottom-right {
  right: 0;
  bottom: 0;
  border-width: 0 3px 3px 0;
}
.qr-cover {
  position: absolute;
  inset: 17px;
  color: #fff;
  cursor: pointer;
  background: rgba(20, 31, 45, 0.76);
  border: 0;
  line-height: 22px;
}
.qr-subtitle {
  margin-bottom: 12px;
  text-align: center;
}
.qr-agreement {
  font-size: 12px;
  line-height: 18px;
  text-align: center;
}
.login-footer {
  align-self: end;
  color: #60728c;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
}
.platform-name {
  margin-bottom: 3px;
  color: #172033;
  font-size: 16px;
  font-weight: 600;
}
.login-footer a {
  color: #60728c;
  text-decoration: none;
}
.login-footer a:hover {
  color: #5CC300;
  text-decoration: underline;
}
@media (max-width: 480px) {
  .login-page {
    gap: 20px;
    padding: 18px 14px 14px;
  }
  .login-brand {
    gap: 10px;
  }
  .brand-logo {
    width: 126px;
  }
  .brand-certification {
    width: 78px;
  }
  .login-panel {
    width: 100%;
    max-width: 386px;
    padding-right: 24px;
    padding-left: 24px;
  }
  .login-footer {
    font-size: 11px;
    line-height: 18px;
  }
  .platform-name {
    font-size: 15px;
  }
  .copyright {
    max-width: 340px;
  }
}
</style>
